import React, { useState, useEffect } from "react";
import { TextField, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { doc, setDoc, addDoc, serverTimestamp, collection } from "firebase/firestore";
import { db } from "firebaseDb";

function OperatorNotes({ sprayInfo, setLoading, loading }) {
  const [opNotes, setOpNotes] = useState(""); // Local state for operator notes

  useEffect(() => {
    setOpNotes(sprayInfo.opNotes || "");
  }, [sprayInfo]);

  const handleSaveNotes = async () => {
    try {
      setLoading(true);

      // 1️⃣ Save notes inside the Spray document
      const docRef = doc(db, "Sprays", sprayInfo.key);
      await setDoc(docRef, { opNotes }, { merge: true });

      // 2️⃣ Also save a copy into the Notes collection
      await addDoc(collection(db, "Notes"), {
        message: opNotes, // note content
        sprayID: sprayInfo.sprayInstructionId, // orderID reference
        siteName: sprayInfo.siteName, // site name
        read: false, // default unread
        createdAt: serverTimestamp(), // timestamp
      });

      setLoading(false);
    } catch (error) {
      console.error("Error saving notes:", error);
      setLoading(false);
    }
  };

  return (
    <MDBox mt={2} width="100%" bgColor="lightgrey" borderRadius={10} p={2}>
      <MDTypography
        variant="caption"
        fontWeight="bold"
        color="dark"
        textTransform="uppercase"
        sx={{ marginBottom: "10px", fontSize: "1rem" }}
      >
        Operator Notes:
      </MDTypography>
      <TextField
        fullWidth
        multiline
        rows={1}
        variant="outlined"
        placeholder="Enter operator's notes here..."
        value={opNotes} // Use local state for the field value
        onChange={(e) => setOpNotes(e.target.value)} // Update local state on change
        sx={{ marginBottom: "10px", backgroundColor: "white" }}
      />
      <MDButton
        variant="contained"
        color="primary"
        onClick={handleSaveNotes}
        disabled={loading} // Disable button while saving
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : "Save Notes"}
      </MDButton>
    </MDBox>
  );
}

export default OperatorNotes;
